import { createApp } from "vue";

import config from "@/app/config.js";
import router from "@/app/router";
import i18n, { loadLocaleMessages } from "@/i18n";
import Axios from "@/plugins/axios";
import initSentry from "@/plugins/sentry.js";

import store from "@/store";
import App from "./App";

import "bootstrap-icons/font/bootstrap-icons.css";
import "@vuepic/vue-datepicker/dist/main.css";
import "@/plugins/veeValidate.js";
import "@/app/styles/main.scss";

// Unregister any zombie service workers from previous versions of the app.
// The register-service-worker package was previously installed but never properly
// configured. Any leftover service workers could intercept requests and serve
// stale cached responses indefinitely.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}

await (async () => {
  const locale = localStorage.getItem("locale") || "en";
  await loadLocaleMessages(locale);
  if (locale !== "en") {
    await loadLocaleMessages("en");
  }

  const app = createApp(App);

  if (config.VITE_APP_IS_ONPREM === "off") {
    initSentry(app, router);
  }

  app.use(i18n);

  // app.provide("$http", Axios);
  app.config.globalProperties.$http = Axios;

  const token = localStorage.getItem("token");

  if (token) {
    app.config.globalProperties.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  app.use(router);
  app.use(store);

  app.mount("#app");
})();
